import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './styles/footer.scss'; 

const Footer = () => {
    return (
      <footer className="footer">
        <section className="Credit">
          <div className="Credit__text">
              <p>Copyright (c) 2024 Quadravita All Rights Reserved.</p>
          </div>
        </section>
      </footer>
    );
  };

export default Footer;